import React from "react"

interface Props {
  label: string
}

export default function Tag({ label }: Props) {
  return (
    <div className="py-0.25 px-2 rounded-8 bg-blueBg flex items-center justify-center">
      <p className="text-16 leading-h6 tracking-9 text-blueText font-black truncate">{label}</p>
    </div>
  )
}
